import { useNavigate } from 'react-router-dom';
import { useBuilds, isActiveBuild, formatBuildAge } from '../lib/useBuilds.ts';
import { buildDestination } from '../lib/buildRoute.ts';

/**
 * A row of "still building" strips above the dashboard grid, each opening that
 * build's `/build/:jobId`.
 *
 * A deck under construction is hard to find any other way. It does appear in
 * the grid once its scaffold lands — `build-workspace` keeps `decks/<slug>` at
 * its real path — but only as a shell: the dashboard withholds its cover and the
 * editor redirects to the build watcher, both because slide 1 is still being
 * written. So a build you started and walked away from would otherwise leave no
 * trace on the one page you'd go back to. Renders nothing when nothing is
 * building.
 */
export default function BuildsInProgress() {
  const { builds } = useBuilds();
  const navigate = useNavigate();
  const active = (builds || []).filter(isActiveBuild);
  if (!active.length) return null;

  return (
    <ul className="page__band building-row" aria-label="Builds in progress">
      {active.map((b) => (
        <li key={b.id}>
          <button
            type="button"
            className="building-strip"
            onClick={() => navigate(buildDestination(b), { state: { slug: b.slug } })}
          >
            <span className="builds-indicator__dot" aria-hidden="true" />
            <span className="building-strip__name">{b.slug || 'New deck'}</span>
            <span className="muted building-strip__status">
              {b.status === 'paused' ? 'waiting on you' : b.phase || 'building'}
              {typeof b.slides === 'number' ? ` · ${b.slides} slide${b.slides === 1 ? '' : 's'}` : ''}
              {` · ${formatBuildAge(b.startedAt)}`}
            </span>
            <span className="building-strip__go">Watch</span>
          </button>
        </li>
      ))}
    </ul>
  );
}
